import { useQuery } from '@gogame/query';

import { loadTable } from '../sources/DataTable';
import { grid } from './queryKeyFactory';
import { useMemo, useRef } from 'react';
import { useScreenMessage } from '@gogame/screens';

const sharedQueryConfig = {
  retry: false,
  cacheTime: 1000 * 60 * 5,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
};

const initialData = {
  dimensionName: undefined,
  drillItems: [],
  columns: [],
  compareMode: false,
  subHeaderRows: [],
  count: 0,
};
function useActivateOnce() {
  const _flgRef = useRef(false);

  return useMemo(() => {
    if (!_flgRef.current) {
      _flgRef.current = true;
    }
    return _flgRef.current;
  }, []);
}

export const useLoadHourlyTrackerTable = (params, { ready }) => {
  const { showWarningMessage } = useScreenMessage();
  const fetchOnMount = useActivateOnce();
  const paramsWithSortedOrder = {
    ...params,
    columns: {
      order: [...params.columns.order].sort(),
    },
  };
  return useQuery(
    grid(paramsWithSortedOrder),
    (_, { signal }) => {
      return loadTable(params, { signal }).then(
        ({ rows, subHeaderRows, ...rest }) => {
          return {
            rows: [
              ...subHeaderRows.map((item, i) => ({
                isTotalValue: true,
                pinned: i === 0,
                ...item,
              })),
              ...rows,
            ],
            ...rest,
          };
        }
      );
    },
    {
      ...sharedQueryConfig,
      onSuccess: ({ warnings }) => {
        warnings.length && showWarningMessage(warnings, { multiple: true });
      },
      keepPreviousData: ready,
      refetchOnMount: fetchOnMount,
      enabled: ready,
      initialData: initialData,
    }
  );
};
